import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initSentry, Sentry } from "./lib/sentry";
import App from "./App.tsx";
import "./index.css";

import { ErrorBoundaryFallback } from "./components/ErrorBoundaryFallback";

initSentry();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={({ error, resetError }) => <ErrorBoundaryFallback error={error as Error} resetError={resetError} />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
